import React, { FormEvent, useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import LeaseClauseType from 'src/models/LeaseClauseType';
import ContractAdHocClause from './ContractGenerationModels/ContractAdHocClause';
import RHFTextArea from 'src/components/controls/tempRHFControls/RHFTextArea';

interface IAdHocClausesProps extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'getValues' | 'setValue'>> {
    leaseClauses: Array<ContractAdHocClause>;
    namePrefix: string;
    leaseClauseTypes?: Array<LeaseClauseType>;
    disabled?: boolean;
}

const AdHocClauses = (props: IAdHocClausesProps) => {
    const [clauseList, setClauseList] = useState<Array<ContractAdHocClause>>([]);
    const [selectedTypes, setSelectedTypes] = useState<boolean[]>([]);

    useEffect(() => {
        let typeList = [];

        if (props.leaseClauses?.length > 0) {
            for (let lc of props.leaseClauses) {
                if (lc.leaseClauseTypeId > 0) {
                    typeList.push(true);
                } else {
                    typeList.push(false);
                }
            }
            setClauseList(props.leaseClauses);
        }
        setSelectedTypes(typeList);
    }, [props.leaseClauses]);

    const checkType = (e: FormEvent<HTMLSelectElement>, index: number) => {
        const fieldType = e.target as HTMLSelectElement;
        let typeList = [...selectedTypes];

        typeList[index] = fieldType.value !== '-- Select --';
        setSelectedTypes(typeList);
    };

    const onAddClause = () => {
        let newList = [...clauseList];

        newList.push(new ContractAdHocClause());
        props.setValue(`${props.namePrefix}[${newList.length - 1}].id`, '');
        props.setValue(`${props.namePrefix}[${newList.length - 1}].leaseClauseTypeId`, 1);
        props.setValue(`${props.namePrefix}[${newList.length - 1}].clauseText`, '');

        setClauseList(newList);
    };

    const onRemoveClause = (index: number) => {
        let newList = [...clauseList];
        for (let i = index; i < newList.length - 1; i++) {
            props.setValue(`${props.namePrefix}[${i}].id`, newList[i + 1].id);
            props.setValue(`${props.namePrefix}[${i}].leaseClauseTypeId`, newList[i + 1].leaseClauseTypeId);
            props.setValue(`${props.namePrefix}[${i}].clauseText`, newList[i + 1].clauseText);
        }
        newList.pop();
        setClauseList(newList);
    };

    return (
        <div>
            <div style={{ margin: 'auto 2rem', maxHeight: '53vh', overflow: 'auto' }}>
                {clauseList.map((field, index) => {
                    return (
                        <div key={`AdHoc-${index}`} style={{ borderBottom: '1px solid darkgrey', marginBottom: '0.5rem', padding: '1rem' }}>
                            <div>
                                <input type="hidden" name={`adHocClauses[${index}].id`} ref={props.register()} />
                                <input type="hidden" name={`adHocClauses[${index}].contractLookupId`} ref={props.register()} />
                                <input type="hidden" name={`adHocClauses[${index}].leaseId`} ref={props.register()} />
                                <RHFSelect
                                    label="Clause Type"
                                    name={`adHocClauses[${index}].leaseClauseTypeId`}
                                    rules={{ required: 'field required' }}
                                    isRequired={true}
                                    register={props.register}
                                    errors={props.errors} 
                                    options={props.leaseClauseTypes.map((lct) => {
                                        return { value: lct.id, label: lct.name };
                                    })}
                                    onChange={(e) => checkType(e, index)}
                                />
                                <RHFTextArea
                                    label=""
                                    name={`adHocClauses[${index}].clauseText`}
                                    register={props.register}
                                    errors={props.errors}
                                    style={{ height: '10rem', width: '100%' }}
                                    disabled={selectedTypes[index] !== true}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button onClick={() => onRemoveClause(index)} text="Delete" size="small" />
                                </div>
                            </div>

                        </div>
                    );
                })}
            </div>
            
            <div style={{ margin: 'auto 2rem' }}>
                <Button 
                    className="blue-hover-button" 
                    onClick={onAddClause} 
                    text="Add Clause" 
                    disabled={props.disabled} 
                    style={{marginTop: '1rem'}} 
                />
            </div>
        </div>
    );
};

export default AdHocClauses;



// WEBPACK FOOTER //
// ./src/components/project/sections/LeasingComponents/redesign/AdHocClauses.tsx